export default "__VITE_ASSET__d3b80476__"